import { createContext, useContext } from 'react';
export const PdfParagraphsContext = createContext(null);
export function usePdfParagraphs() {
    const context = useContext(PdfParagraphsContext);
    if (!context) {
        throw new Error('usePdfParagraphs must be used within a PdfParagraphsProvider');
    }
    return context;
}
//# sourceMappingURL=PdfParagraphsContext.js.map